module.exports = __webpack_public_path__ + "images/Dislike.9c67a0b624838de9dc7e50fe639985ac.svg";